import axios from 'axios';

import { USERS_URL } from './urls';

export const useGetAllUsers = () => {
  return async () => {
    try {
      const res = await axios.get(USERS_URL, {
        headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
      });
      return res.data?.users ?? [];
    } catch (e) {
      return [];
    }
  };
};

export const useCreateUsers = () => {
  return async (name, phoneNumber, emailAddress, password) => {
    try {
      await axios.post(
        USERS_URL,
        { name, phoneNumber, emailAddress, password },
        {
          headers: { Authorization: 'bearer ' + localStorage.getItem('token') }
        }
      );
      return true;
    } catch (e) {
      return false;
    }
  };
};
